{
	"affiliate": "Affiliate",
	"info-about-sender": "Sender info",
	"info-about-receiver": "Receiver info",
	"info-about-shipment": "Info about shipment",
	"nameContinue": "Name continue",
	"addressContinue": "Address continue",
	"packageDescription": "Packaging description in English",
	"contents": "Contents in English",
	"contentsValue": "Value of content (ISK)",
	"comments": "Comments",
	"comments-more": "Comments - in english if possible",
	"mission": "What is your issue?",
	"missionOptions": {
		"option1": "Letters/bulk mail distribution",
		"option2": "Parcel/Parcel distribution",
		"option3": "Other"
	},
	"messageType": "Message type",
	"messageTypeOptions": {
		"option1": "Customer feedback",
		"option2": "Complaint",
		"option3": "Compliments"
	},
	"residence": "Residence",
	"feedbackPlaceholder": "Write here...",
	"feedbackLabel": "Share your thoughts"
}
